export default __webpack_public_path__ + "static/media/InsideBones_00.04149592.png";